import React, { useCallback, useEffect, useState } from 'react';
import { useFetch } from '../../shared/hooks/useFetch';
import Clouds from './cloud.png';
import Rain from './rain.png';
import Snow from './snow.png';
import Sun from './sun.svg';
import clsx from 'clsx';
import style from './style.module.scss';

const icons = {
    Sunny: Sun,
    Clear: Sun,
    Clouds: Clouds,
    Rain: Rain,
    Snow: Snow,
};

const apiKey = 'b46e24cc7c314d4f115b472e77316410';

const WeatherTime = ({ ...props }) => {
    const [icon, setIcon] = useState(null);
    const [weather, setWeather] = useState('');
    const [temperature, setTemperature] = useState(0);

    const fetch = useFetch();

    const loadWeather = useCallback(async () => {
        const params = new URLSearchParams({
            q: 'arcachon',
            appid: apiKey,
            units: 'metric',
            lang: 'fr',
        });

        try {
            const response = await fetch('https://api.openweathermap.org/data/2.5/weather?' + params.toString()).then(
                (response) => response.json(),
            );
            if (response) {
                setWeather(response.weather[0].description ?? '');
                setIcon(icons[response.weather[0].main] ?? null);
                setTemperature(Math.round(response.main.temp ?? 0));
            }
        } catch (e) {
            if (!(e instanceof DOMException) || e.code !== e.ABORT_ERR) {
                console.error(e);
            }
        }
    }, [fetch]);

    useEffect(() => {
        loadWeather();
    }, [loadWeather]);

    return weather ? (
        <div {...props} className={clsx(style.weatherTime, props.className)}>
            {icon && <img src={icon} alt={weather} title={weather} />}
            <p className={style.temp}>{temperature + '°C'}</p>
        </div>
    ) : null;
};

export default WeatherTime;
